export const addErrorReportingTag = ({
    name,
    value,
}: {
    name: string;
    value: string;
}) => {
    if (window.loggerClient) {
        window.loggerClient.metaData = window.loggerClient.metaData || {};
        window.loggerClient.metaData.tags =
            window.loggerClient.metaData.tags || {};
        window.loggerClient.metaData.tags[name] = value;
    }
};
